"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview27_exports = {};
__export(GeodesPreview27_exports, {
  default: () => GeodesPreview27_default
});
module.exports = __toCommonJS(GeodesPreview27_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.42578 9.50781C8.5013 9.50781 7.71354 9.18229 7.0625 8.53125C6.41146 7.88021 6.08594 7.09245 6.08594 6.16797C6.08594 5.24349 6.41146 4.45573 7.0625 3.80469C7.71354 3.15365 8.5013 2.82812 9.42578 2.82812C10.3372 2.82812 11.1185 3.15365 11.7695 3.80469C12.4206 4.45573 12.7461 5.24349 12.7461 6.16797C12.7461 7.09245 12.4206 7.88021 11.7695 8.53125C11.1185 9.18229 10.3372 9.50781 9.42578 9.50781ZM9.42578 8.49219C10.0638 8.49219 10.6107 8.26432 11.0664 7.80859C11.5221 7.35286 11.75 6.80599 11.75 6.16797C11.75 5.51693 11.5221 4.96354 11.0664 4.50781C10.6107 4.05208 10.0638 3.82422 9.42578 3.82422C8.77474 3.82422 8.22135 4.05208 7.76562 4.50781C7.3099 4.96354 7.08203 5.51693 7.08203 6.16797C7.08203 6.80599 7.3099 7.35286 7.76562 7.80859C8.22135 8.26432 8.77474 8.49219 9.42578 8.49219ZM6.92578 12.1836C6.13151 12.1836 5.45443 12.4635 4.89453 13.0234C4.34766 13.5703 4.07422 14.2344 4.07422 15.0156V16.5195C4.07422 16.6497 4.02214 16.7669 3.91797 16.8711C3.82682 16.9622 3.71615 17.0078 3.58594 17.0078C3.44271 17.0078 3.31901 16.9622 3.21484 16.8711C3.1237 16.7669 3.07812 16.6497 3.07812 16.5195V15.0156C3.07812 14.4818 3.18229 13.987 3.39062 13.5312C3.58594 13.0625 3.85286 12.6589 4.19141 12.3203C4.54297 11.9688 4.95312 11.6888 5.42188 11.4805C5.89062 11.2852 6.39193 11.1875 6.92578 11.1875H11.3398C11.4701 11.1875 11.5807 11.2396 11.6719 11.3438C11.776 11.4349 11.8281 11.5456 11.8281 11.6758C11.8281 11.819 11.776 11.9427 11.6719 12.0469C11.5807 12.138 11.4701 12.1836 11.3398 12.1836H6.92578ZM14.25 10.9141C14.3932 10.9141 14.5104 10.9661 14.6016 11.0703C14.7057 11.1615 14.7578 11.2786 14.7578 11.4219V13.8242H17.1602C17.3034 13.8242 17.4206 13.8763 17.5117 13.9805C17.6159 14.0716 17.668 14.1888 17.668 14.332C17.668 14.4753 17.6159 14.599 17.5117 14.7031C17.4206 14.7943 17.3034 14.8398 17.1602 14.8398H14.7578V17.2422C14.7578 17.3854 14.7057 17.5091 14.6016 17.6133C14.5104 17.7044 14.3932 17.75 14.25 17.75C14.1068 17.75 13.9831 17.7044 13.8789 17.6133C13.7878 17.5091 13.7422 17.3854 13.7422 17.2422V14.8398H11.3398C11.1966 14.8398 11.0729 14.7943 10.9688 14.7031C10.8776 14.599 10.832 14.4753 10.832 14.332C10.832 14.1888 10.8776 14.0716 10.9688 13.9805C11.0729 13.8763 11.1966 13.8242 11.3398 13.8242H13.7422V11.4219C13.7422 11.2786 13.7878 11.1615 13.8789 11.0703C13.9831 10.9661 14.1068 10.9141 14.25 10.9141Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview27 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview27_default = SvgGeodesPreview27;
